var map = {
	"./actionLog.svg": "ne3Q",
	"./addSoild.svg": "pkkb",
	"./android.svg": "DfSc",
	"./chart.svg": "RjYk",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./fairguard.svg": "RBZB",
	"./feature.svg": "tBIV",
	"./featureTask.svg": "OPrL",
	"./flagTask.svg": "OY9W",
	"./form.svg": "sTIr",
	"./gameKey.svg": "6/6A",
	"./home.svg": "U9Ws",
	"./ios.svg": "+yoS",
	"./localFeature.svg": "mmyL",
	"./login-swp.svg": "kJB3",
	"./login-swp2.svg": "45rX",
	"./marker.svg": "0+/s",
	"./mining.svg": "2fy0",
	"./modelVersion.svg": "QlgG",
	"./monitor.svg": "Lu+8",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./plugIn.svg": "MATk",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./punishment.svg": "3TtF",
	"./riskTrend.svg": "ifZi",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./table.svg": "oSYw",
	"./threatData.svg": "3OAc",
	"./toolVersion.svg": "9oJ+",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 78